import _ from "lodash";
import Vue from "vue";
import Router from "vue-router";

// Components
// import Home from "../components/Home.vue";
import Post from "../components/Post/Post.vue";
import Page from "../components/Page/Page.vue";
// import Layout from "../views/layout/Layout.vue";
import config from '../config';

Vue.use(Router);

const router = new Router({
  routes: [
    // {
    //   path: "/",
    //   name: "Home",
    //   component: Home
    // },
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/feature',
      name: 'feature',
      component: () => import('../views/Feature.vue'),
      meta: { title: '機能' }
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('../views/Pricing.vue'),
      meta: { title: '料金' }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/Contact.vue'),
      meta: { title: 'お問い合わせ' }
    },
    {
      path: '/asct',
      name: 'asct',
      component: () => import('../views/Asct.vue'),
      meta: { title: '特定商取引法に基づく表記' }
    },
    {
      path: '/termsofservice',
      name: 'termsofservice',
      component: () => import('../views/TermsOfService.vue'),
      meta: { title: '利用規約' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About.vue'),
      meta: { title: '開発元について' }
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: () => import('../views/PrivacyPolicy.vue'),
      meta: { title: 'プライバシーポリシー' }
    },
    {
      // Assuming you're using the default permalink structure for posts
      path: "/:year/:month/:day/:postSlug",
      name: "Post",
      component: Post
    },
    {
      path: "/:pageSlug",
      name: "Page",
      component: Page
    },
  ],
  mode: "history",
  base: "",

  // Prevents window from scrolling back to top
  // when navigating between components/views
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// router.beforeEach((to, from, next) => {
router.beforeEach((to, _, next) => {
  let title = config.siteTitle;
  if (to.meta && to.meta.title) {
    title = to.meta.title + ' | ' + title;
  }
  document.title = title;

  next()
})

router.afterEach((to, from) => {
  // Add a body class specific to the route we're viewing
  let body = document.querySelector("body");
  // let bodyClasses = body.className.split(" ");

  // if (bodyClasses.length > 0) {
  //   const newBodyClasses = bodyClasses.filter(theClass =>
  //     theClass.startsWith("vue--page--")
  //   );
  // }

  const slug = _.isEmpty(to.params.postSlug)
    ? to.params.pageSlug
    : to.params.postSlug;
  body.classList.add("vue--page--" + slug);

});

export default router;
